import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


import Dialog from '../../services/Dialogs'




const ModalSupervisorListaSupervisados = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, usuario } = params

  const dialog = new Dialog();


  const [ listado_supervisados, setListado_supervisados ] = useState<any>([])
  const [ envio_server, setSeEnvio ] = useState<boolean>(false)
  const cargarListado_supervisados = async()=>{
    try{
      setSeEnvio(true)
      let response : any = await RequestService.getEndPoint(`supervisor/lista_supervisados/${usuario.uuid}`)
      setListado_supervisados(response.data)
      setSeEnvio(false)
    }
    catch(e){
      console.log(e)
      setSeEnvio(false)
      toast.error('Problemas al intentar cargar')
    }
  }


  React.useEffect(() => {
    cargarListado_supervisados()
  }, []);




const enviarFormulario = async (event:any,uuid_asesor:string) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro?',
        target: event.target,
        template: ``
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `supervisor/eliminar_asesor_lista/${usuario.uuid}` , { uuid_asesor : uuid_asesor })

        if(res_){
          toast.success('El Asesor se quitó de la lista')
          setTimeout(()=>{
            cargarListado_supervisados()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){

          if (e.response?.status) {
            switch (e.response.status) {
              case 404:
                toast.error("No pudimos realizar la acción")
                break;
              default:
                toast.error(e.response?.data)
            }
          }
          else{
            toast.error("Problemas con la busqueda")
          }
          setSeEnvio(false)

        }
        
      }
     
}


  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Lista de Supervisor</Modal.Title>
        </Modal.Header>
        <Modal.Body>


                    <small>Supervisor</small>
                    <p>{usuario.nombres} {usuario.paterno} {usuario.materno} </p>

                    <small>Sucursal</small>
                    <p>{usuario.idsucursal.nombre_sucursal}</p>

          {
            // JSON.stringify(usuario)
          }

          {
            // JSON.stringify(listado_supervisados)
          }

          <ul className="list-group list-group-flush list-group-numbered">
              {
                listado_supervisados.length > 0 && (

                    <React.Fragment>

                      <small className="mb-2">Lista de Asesores</small>
                      
                      {
                        listado_supervisados.map(( asesor:any, indice_supervisado:number )=>
                              <li key={indice_supervisado} className="list-group-item d-flex justify-content-between align-items-start">
                                <div className="ms-2 me-auto">
                                  <div className="fw-bold">
                                    {asesor.nombres} {asesor.paterno} {asesor.materno} 
                                  </div>
                                  <small>{usuario.idsucursal.nombre_sucursal}</small>
                                </div>
                                <span onClick={(e:any)=>{enviarFormulario(e,asesor.uuid)}} className="badge text-bg-primary rounded-pill cursor"><i className="fa fa-trash"/></span>
                              </li>
                          )
                      }

                    </React.Fragment>

                  )
              }
          </ul>



              {
                listado_supervisados.length === 0 && (

                    <React.Fragment>

                          <div className="alert alert-danger" role="alert">
                            Este supervisor no tienen Asesores Asignados
                          </div>

                    </React.Fragment>

                  )
              }

        </Modal.Body>
      </Modal>
    </>
  );
}


export default ModalSupervisorListaSupervisados;